import { render, staticRenderFns } from "./PopUpHolder.vue?vue&type=template&id=0c95c770&scoped=true&"
import script from "./PopUpHolder.vue?vue&type=script&lang=js&"
export * from "./PopUpHolder.vue?vue&type=script&lang=js&"
import style0 from "./PopUpHolder.vue?vue&type=style&index=0&id=0c95c770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95c770",
  null
  
)

export default component.exports